import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterReg.styl';


import './BXmakerAuthuserphoneEnterSmsCode';
import './BXmakerAuthuserphoneEnterUserCall';
import './BXmakerAuthuserphoneEnterBotCall';
import './BXmakerAuthuserphoneEnterBotSpeech';
import './BXmakerAuthuserphoneEnterRegForm';


Vue.component('BXmakerAuthuserphoneEnterReg', {
    name: 'BXmakerAuthuserphoneEnterReg',
    data() {
        return {};
    },
    computed: {},
    methods: {

    },

    template: `
            <div class="bxmaker-authuserphone-enter-reg"  >
                
                 <BXmakerAuthuserphoneHeader class="bxmaker-authuserphone-enter-reg__title" >
                    {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REGISTRATION_TITLE}}
                 </BXmakerAuthuserphoneHeader>  
                
                                              
                 <BXmakerAuthuserphoneEnterRegForm 
                    v-show="!$root.isShowConfirmation" 
                 />   
                                        
                 <BXmakerAuthuserphoneEnterSmsCode  
                     v-show="$root.isNeedShowConfirmationSmsCode"                                    
                 /> 
                    
                 <BXmakerAuthuserphoneEnterUserCall  
                     v-show="$root.isNeedShowConfirmationUserCall"   
                 /> 
                    
                 <BXmakerAuthuserphoneEnterBotCall 
                      v-show="$root.isNeedShowConfirmationBotCall"                 
                 />  
                 
                 <BXmakerAuthuserphoneEnterBotSpeech 
                      v-show="$root.isNeedShowConfirmationBotSpeech"                 
                 />  
                 
                    
                 <div class="bxmaker-authuserphone-enter-reg__change-confirm" v-if="$root.isNeedShowChangeConfirmation"  >
                      <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmationType" >
                         {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_CHANGE_CONFIRM_TYPE}}   
                      </BXmakerAuthuserphoneLink> 
                 </div>   
                    
                 <div class="bxmaker-authuserphone-enter-reg__toauth" v-if="!$root.isShowConfirm">
                      <BXmakerAuthuserphoneLink @onClick="$root.toAuth" >
                             {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_TO_AUTH}}   
                     </BXmakerAuthuserphoneLink> 
                 </div>   
                
                             
            </div>
        `,
});